<template>
  <div class="table-settings py-6">
    <div class="table-list-header">
      <div class="text-2xl font-semibold text-vp-base-900">
        Venues
      </div>
      <router-link
        :to="{ name: 'VenueNew' }"
        class="hover:no-underline"
      >
        <div
          class="flex items-center justify-center fixed bottom-16 right-16 w-14 h-14 sm:h-37 sm:w-30 sm:static bg-vp-primary-900 rounded-full sm:rounded-lg"
        >
          <span class="hidden sm:inline-block text-vp-base-100 text-sm font-semibold">Add</span>
          <Plus class="sm:hidden text-vp-base-100 h-6 w-6" />
        </div>
      </router-link>
    </div>
    <div
      v-if="venueLoading"
      class="text-center"
    >
      Loading...
    </div>
    <div
      v-else
      class="table-list"
    >
      <div class="table-list-item">
        <div class="header-name">
          Name
        </div>
        <div class="header-name">
          Address
        </div>
      </div>
      <router-link
        v-for="venue in venues"
        :key="venue.id"
        :to="{ name: 'VenueEdit', params: { venueId: venue.id } }"
        class="table-list-item table-link"
      >
        <div class="table-cell-content">
          {{ venue.name }}
        </div>
        <div class="table-cell-content">
          {{ formatAddress(venue.address) }}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useVenueStore } from '@/stores/venue';
import type { Address } from '@/types/Address';
import { computed } from 'vue';
import { Plus } from 'mdue';

const venueStore = useVenueStore();

venueStore.fetchAllVenues();
const venues = computed(() => venueStore.venues);
const venueLoading = computed(() => venueStore.venueLoading);

function formatAddress(address?: Address): string {
  if (!address) {
    return '';
  }

  const addressKeys: string[] = ['street1', 'street2', 'city', 'state', 'postalCode', 'country'];
  return addressKeys
    .filter(key => address[key])
    .map(key => (address[key] || '').trim())
    .join(', ');
}
</script>
